import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

export default class SliderImg {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.slider-img--slider')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      modules: [Autoplay],
      slidesPerView: 1,
      loop: true,
      grabCursor: true,
      speed: 500,
      autoplay: { delay: 3500, disableOnInteraction: false },
    })

    const container = this.el.querySelector('.slider-img--container')
    if (!container) return

    const slides = swiperEl.querySelectorAll('.swiper-slide')
    if (slides.length <= 1) {
      container.querySelectorAll('.slider-img--arrow').forEach(a => a.style.display = 'none')
      this.swiper.autoplay.stop()
      return
    }

    container.querySelector('.slider-img--arrow.prev')?.addEventListener('click', () => this.swiper.slidePrev())
    container.querySelector('.slider-img--arrow.next')?.addEventListener('click', () => this.swiper.slideNext())
  }
}
